import { createFileRoute, Link } from "@tanstack/react-router"
import { blogPosts, formatBlogDate } from "@/lib/blog-posts"
import { defaultMeta } from "@/lib/seo"

export const Route = createFileRoute(`/_public/blogs/`)({
  ssr: true,
  head: () =>
    defaultMeta({
      title: `Blog`,
      description: `Travel tips, destination guides, packing advice, and ChicTravel product updates — everything you need to plan smarter trips.`,
      path: `/blogs`,
    }),
  component: BlogsPage,
})

function BlogsPage() {
  return (
    <div className="max-w-5xl mx-auto px-6 py-16 space-y-10">
      <div className="space-y-3">
        <h1 className="text-4xl font-extrabold tracking-tight">Blog</h1>
        <p className="text-muted-foreground text-lg">
          Travel tips, destination guides, packing advice, and product updates.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {blogPosts.map((post) => (
          <Link
            key={post.slug}
            to="/blogs/$slug"
            params={{ slug: post.slug }}
            className="group block"
          >
            <article className="h-full rounded-2xl border border-border bg-card hover:border-primary/40 hover:bg-muted/40 transition-all duration-200 overflow-hidden flex flex-col">
              <div className="relative h-44 overflow-hidden bg-muted/40">
                <img
                  src={post.coverImage}
                  alt={post.coverAlt}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5 flex flex-col gap-2 flex-1">
                <div className="flex items-center gap-2 text-xs text-muted-foreground">
                  <span>{formatBlogDate(post.date)}</span>
                  <span>·</span>
                  <span>{post.readTime}</span>
                </div>
                <h2 className="text-base font-bold leading-snug group-hover:text-primary transition-colors">
                  {post.title}
                </h2>
                <p className="text-sm text-muted-foreground leading-relaxed flex-1 line-clamp-3">
                  {post.excerpt}
                </p>
                <span className="text-xs font-semibold text-primary mt-1">
                  Read more →
                </span>
              </div>
            </article>
          </Link>
        ))}
      </div>
    </div>
  )
}
